import TalentIntroducedToCustomerRow from "./TalentIntroducedToCustomerRow";
import { TalentIntroductionRow } from "../../types";
import { useState } from "react";
import { Nullable } from "../../../../../common/types/nullable";
import TalentIntroductionsActionMenu from "./TalentIntroductionsActionMenu";

type Props = {
  rows: TalentIntroductionRow[];
  selectActionForIntroduction?: (id: string, action: string) => void;
  withOrder?: boolean;
};

const TalentIntroducedToCustomerRows = ({
  rows,
  selectActionForIntroduction,
  withOrder,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<Nullable<HTMLElement>>(null);

  const handleCloseMenu = () => setAnchorEl(null);
  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);

  return (
    <>
      {rows.map((row, index) => (
        <TalentIntroducedToCustomerRow
          key={`${row.bundleId ?? row.workLocationId}-${row.talentId}`}
          row={row}
          index={index}
          onClick={selectActionForIntroduction ? handleOpenMenu : undefined}
          withOrder={withOrder}
        />
      ))}
      {selectActionForIntroduction && (
        <TalentIntroductionsActionMenu
          anchorEl={anchorEl}
          onClose={handleCloseMenu}
          selectActionForIntroduction={selectActionForIntroduction}
        />
      )}
    </>
  );
};

export default TalentIntroducedToCustomerRows;
